import { type FC } from 'react'
import { useWealthboxCalendarSync, useWealthboxContactSync } from '../IntegrationSpecificSettings/Wealthbox/hooks'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

export const WealthboxCrmSettingsProvider: FC<CrmSettingsProviderProps> = ({ children }) => {
  const contact = useWealthboxContactSync()
  const calendar = useWealthboxCalendarSync()

  const settings: CrmIntegrationSettings = {
    contactSync: contact.autoSync ?? false,
    calendarSync: calendar.autoSync,
    isSyncDisabled: contact.isSyncDisabled,
    isFetching: contact.isFetching || calendar.isFetching,
    isSaving: contact.isSaving || calendar.isSaving,
    save: async (patch) => {
      const ops: Promise<unknown>[] = []
      if (patch.contactSync !== undefined) {
        ops.push(contact.saveAutoSync(patch.contactSync))
      }
      if (patch.calendarSync !== undefined) {
        ops.push(calendar.save(patch.calendarSync))
      }
      await Promise.all(ops)
    },
  }

  return <>{children(settings)}</>
}
